<template>
    <div id="app">
        <div class="lazy-box">
            <Header />
            <router-view />
            <Footer />
            <cookieTip />
        </div>
    </div>
</template>

<script>
import Header from '@/components/headers.vue'
import Footer from '@/components/footers.vue'
import cookieTip from '@/components/cookieTip.vue'
import Cookies from 'js-cookie'
export default {
    components: {
        Header,
        Footer,
        cookieTip,
    },
    created() {
        const query = this.$route.query
        if (query.source) {
            this.$store.state.receptionSave.orderSourceId = query.source
            // sessionStorage.setItem('orderSourceId', query.source)
            Cookies.set('orderSourceId', query.source)
        }
    },
}
</script>

<style></style>
